import { EmiBaseInfoService } from 'app/shared/services/emi-base-info.service';
import { EmiDataService } from 'app/emi-data.service';
import { Http } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.css']
})
export class TermsOfUseComponent implements OnInit {
  dataLoaded=false;
  sub;
  termsOfUse;
  title;
  content;
  constructor(
       private route: ActivatedRoute,
       private router: Router,
       private _http:Http,
       private emidataService:EmiDataService,
       private baseInfoService:EmiBaseInfoService,
      ) { }

  ngOnInit() {
    debugger
    this.sub =this.route.snapshot.url[0].path;
    let url='https://api.eloan.loan/v1/page/'+this.sub;
    this.baseInfoService.getPortalPolicies(url).subscribe((result)=>{
      
      this.termsOfUse=result.data;
      this.dataLoaded=true;
      console.log(this.termsOfUse);
  });
   
  }
 

}



// WEBPACK FOOTER //
// ./src/app/about/terms-of-use/terms-of-use.component.ts